import { CanvasContext } from "client/contexts/ResizeEditor/Canvas";
import { loadSrcToImage } from "client/utils/loadSrcToImage";
import { useContext, useEffect, useState, type MutableRefObject } from "react";

export const useLoadFromParentImage = (imageRef: Nullable<MutableRefObject<Nullable<HTMLImageElement>>>) => {
    const { parentImageRef, imageLoaded } = useContext(CanvasContext);
    const [isLoaded, setIsLoaded] = useState(false);

    async function loadImageToCanvas() {
        const parentImage = parentImageRef?.current;
        const image = imageRef?.current;
        if (!parentImage || !image || !imageLoaded) return;
        image.width = parentImage.width;
        image.height = parentImage.height;
        await loadSrcToImage(parentImage.getAttribute("src") || "", image);
        setIsLoaded(true);
    }

    useEffect(() => {
        loadImageToCanvas();
    }, [imageLoaded]);

    return { isLoaded };
};
